import {IOrganization} from "../../interfaces/IOrganization";
import {Grid, Mui, AlertTypes} from "@leap4/frontend";
import React, {useEffect, useState} from "react";
import _ from "lodash";
import {ForeingAccess} from "./ForeingAccess";
import {ApiClient} from "../../../../utils/apiClient";
import {organizationPartnersUrl} from "../../../../config/generals";
import {setAlert} from "../../../../actions/alert";
import Q from "bluebird";

const {Button, Divider} = Mui;

type PartnerOption = string | {id: string, name: string};

export interface IPublisherLoginsProps {
    allOrganizations: Array<IOrganization>,
    updatePublisherLogins: (publisherLogins: IOrganizationPartnersForeingAccess[]) => void, // function to update currentOrgPubLogins
    currentOrganization?: IOrganization // created\edited Organization

}

export interface IOrganizationPartnersForeingAccess {
    org: IOrganization
    optionalPartners: PartnerOption[],
    selectedPartners: string[],
    toSkipDiscrepancy: boolean
    facadeName: string
}

export const ForeingAccessContainer = (props: IPublisherLoginsProps) => {
    const {allOrganizations, updatePublisherLogins, currentOrganization} = props
    const [isAnyPartners, setIsAnyPartners] = useState<boolean>(true);
    const [allPartners, setAllPartners] = useState<PartnerOption[]>([]);
    const getInitialOrg = (foreingAccess?: {
        [organizationId: string]: {
            partners: string[],
            toSkipDiscrepancy: boolean,
            facadeName: string
        }, // array of the supply partners ids
    }): IOrganizationPartnersForeingAccess[] => {
        if (!foreingAccess || _.isEmpty(foreingAccess)) return [{org: null, optionalPartners: [], selectedPartners: [], toSkipDiscrepancy: true,  facadeName: ''}];
        return Object.entries(foreingAccess).map(([orgId, selectedPartners]) => {
            const theOrganization = allOrganizations.find(o => o._id.toString() === orgId)
            return {org: theOrganization, optionalPartners: selectedPartners.partners, selectedPartners: selectedPartners.partners, toSkipDiscrepancy: selectedPartners.toSkipDiscrepancy, facadeName: selectedPartners.facadeName}
        })
    }
    const initialSelectedOrganizations = getInitialOrg(currentOrganization.foreingAccess)
    const [selectedOrganizations, setSelectedOrganizations] = useState<IOrganizationPartnersForeingAccess[]>(initialSelectedOrganizations);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const isMoreOrganizations = () => {
        const _isMoreOrganizations = selectedOrganizations.length !== allOrganizations.length;
        if (_isMoreOrganizations) return {boolean: true, text: 'ADD PUBLISHER LOGIN'};
        return {boolean: false, text: 'NO MORE PUBLISHER LOGINS'}
    }
    const onAddOrganization = () => {
        if (selectedOrganizations.length === allOrganizations.length) return;
        const organizationPartners = [...selectedOrganizations, getInitialOrg()[0]]
        setSelectedOrganizations(organizationPartners);

    }
    const updateSelectedOrgs = async (id: string, previousId: string | undefined) => {
        const organizationToSet = allOrganizations.find(o => o._id === id);
        if (!allPartners) {
            const optionalPartnersForOrg = await getPartnersForOrganization(currentOrganization._id);
            setAllPartners(optionalPartnersForOrg)
        }
        const organizationsToSet = [...selectedOrganizations]

        if (previousId) {
            const previousIndex = selectedOrganizations.findIndex(o => o.org?._id === previousId)
            organizationsToSet[previousIndex] = {
                toSkipDiscrepancy: organizationsToSet[previousIndex].toSkipDiscrepancy,
                org: organizationToSet,
                optionalPartners: allPartners,
                selectedPartners: organizationsToSet[previousIndex].selectedPartners || [],
                facadeName: organizationsToSet[previousIndex].facadeName || ''

            }

        } else {
            const nullIndex = selectedOrganizations.findIndex(o => !o.org?._id)
            organizationsToSet[nullIndex] = {
                toSkipDiscrepancy: organizationsToSet[nullIndex].toSkipDiscrepancy,
                org: organizationToSet,
                optionalPartners: allPartners,
                selectedPartners: [],
                facadeName: organizationsToSet[nullIndex].facadeName || ''
            }

        }
        setSelectedOrganizations(organizationsToSet)
    }

    const handleSkipChange = (forOrganizationId: string, skip: boolean) => {
        const copyOfSelectedOrgs = [...selectedOrganizations];
        const organizationToEditIdx = copyOfSelectedOrgs.findIndex(sO => sO.org._id === forOrganizationId);
        copyOfSelectedOrgs[organizationToEditIdx].toSkipDiscrepancy = skip;
        setSelectedOrganizations(copyOfSelectedOrgs)
    }

    const handlePartnersChange = (chosenPartners: string[], forOrganizationId: string) => {
        const copyOfSelectedOrgs = [...selectedOrganizations];
        const organizationToEditIdx = copyOfSelectedOrgs.findIndex(sO => sO.org._id === forOrganizationId);
        copyOfSelectedOrgs[organizationToEditIdx].selectedPartners = chosenPartners;
        setSelectedOrganizations(copyOfSelectedOrgs)
    }

    const handleOrganizationRemove = (orgIdToRemove: string) => {
        const newSelectedOrgs = selectedOrganizations.filter(o => o.org?._id !== orgIdToRemove);
        setSelectedOrganizations(newSelectedOrgs)
    };


    const getPartnersForOrganization = async (orgId: string) => {
        setIsLoading(true)
        try {
            return (await ApiClient.get(organizationPartnersUrl, {params: {organization: orgId.toString()}})).data;


        } catch (err) {
            setAlert(`Couldn't load Partners, err is: ${err}`, AlertTypes.FAILURE)

        } finally {
            setIsLoading(false)
        }
    }

    const fetchOptionalPartners = async () => {
        const optionalPartners = await getPartnersForOrganization(currentOrganization._id)
        if (!optionalPartners.length) {
            setIsAnyPartners(false)
        }
        setAllPartners(optionalPartners)
        const newSelectedOrgs: IOrganizationPartnersForeingAccess[] = await Q.map(selectedOrganizations, async (o, idx) => {
            return {...o, optionalPartners}
        })
        setSelectedOrganizations(newSelectedOrgs)
    }

    useEffect(() => {
        if (selectedOrganizations.some(o => !o?.org?._id)) return;
        if (selectedOrganizations.some(s => !s.optionalPartners?.length || typeof s.optionalPartners[0] === 'string') && isAnyPartners) {
            fetchOptionalPartners()
        }
        updatePublisherLogins(selectedOrganizations)
    }, [selectedOrganizations]);

    const allSelectedOrgIds = selectedOrganizations.map(o => o.org?._id)
    return (
        <>
        <Grid margin={"10px"}>
            <Divider/>
        </Grid>
            <Grid xs={2} margin={"10px"} item>
                Foreign Access
            </Grid>
            {
                selectedOrganizations.map((sO, idx) => {
                    const availableOrganizations = allOrganizations
                        .filter(org => (allSelectedOrgIds.indexOf(org._id) === -1 && org._id) && org._id !== currentOrganization._id)
                    sO.org?._id && availableOrganizations.unshift(sO.org)
                    return <ForeingAccess organization={sO}
                                          isLoading={isLoading}
                                          handleSkipChange={handleSkipChange}
                                          availableOrganizations={availableOrganizations}
                                          onUpdateSelectedOrgs={updateSelectedOrgs}
                                          onPartnersChange={handlePartnersChange}
                                          onOrganizationRemove={handleOrganizationRemove}
                                          key={sO?.org?._id ? sO?.org?._id : idx + Math.random()}

                    />
                })
            }
            <Grid item xs={2.2}>
                <Button size="medium" variant="contained" color="primary"
                        disabled={!isMoreOrganizations().boolean}
                        onClick={onAddOrganization}>
                    {isMoreOrganizations().text}
                </Button>
            </Grid>
        </>
    )
}
